import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=6f51f89f&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "@/sass/06_atoms/logo.scss?vue&type=style&index=0&id=6f51f89f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f51f89f",
  null
  
)

export default component.exports